module.exports = __webpack_public_path__ + "img/good-5.1e21b880.png";